import classNames from 'classnames';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import {removeToastFromState} from '../../actions/index';
import Toast from '../Toast/Toast';
import ToasterSvgs from './ToasterSvgs';
import './Toaster.less';

export const Toaster = ({
    autoClose,
    position,
    onRemove,
    toasts,
    animation
}) => {
    const toasterClasses = classNames({
        'toaster': true,
        'toaster--is-bottom': position === 'bottom',
        'toaster--is-top': position === 'top',
        'toaster--is-bottom-left': position === 'bottom-left',
        'toaster--is-bottom-right': position === 'bottom-right',
        'toaster--is-top-left': position === 'top-left',
        'toaster--is-top-right': position === 'top-right',
    });

    // if animation is `replace` then remove current toast before adding
    if (animation === 'replace' && toasts.length > 1) {
        onRemove(toasts[0].id);
    }

    return (
        <div className={toasterClasses}>
            <ToasterSvgs />
            {toasts && toasts.map((toast) => {
                const {
                    id,
                    content,
                    closeOnClick,
                    onClick,
                    onClose,
                    onCloseClick,
                    remove,
                    type
                } = toast;
                // support number or false
                const autoCloseProp = typeof toast.autoClose !== 'undefined' ? toast.autoClose : autoClose;
                return (
                    <Toast
                        animation={animation}
                        key={`toast-${id}`}
                        id={id}
                        content={content}
                        autoClose={autoCloseProp}
                        closeOnClick={closeOnClick}
                        onClick={onClick}
                        onClose={onClose}
                        onCloseClick={onCloseClick}
                        remove={remove}
                        removeToastFromState={onRemove}
                        type={type}
                    />
                );
            })}
        </div>
    );
};

Toaster.propTypes = {
    /** Delay in ms to close toasts unless specifically overriden by a toast prop. */
    autoClose: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    /** position toasts in all 4 corners */
    position: PropTypes.oneOf(['bottom', 'top', 'bottom-left', 'bottom-right', 'top-right', 'top-left']),
    /** Display toasts animation as stack or replace */
    animation: PropTypes.oneOf(['stack', 'replace']),
};

Toaster.defaultProps = {
    autoClose: 5000,
    position: 'bottom',
    animation: 'stack'
};

/* istanbul ignore next */
const mapStateToProps = (state = {}) => {
    const toasts = state.toaster || [];
    return {toasts};
};

/* istanbul ignore next */
const mapDispatchToProps = {
    onRemove: removeToastFromState
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Toaster);